export default __webpack_public_path__ + "static/media/01Orchha.506f5618.jpg";